/* Intl */
// Brasil
import '@progress/kendo-angular-intl/locales/pt/all';
// Alemanha
import '@progress/kendo-angular-intl/locales/de/all';
// Espanha
import '@progress/kendo-angular-intl/locales/es/all';
// Estados Unidos
import '@progress/kendo-angular-intl/locales/en/all';
// França
import '@progress/kendo-angular-intl/locales/fr/all';
// África do Sul
import '@progress/kendo-angular-intl/locales/en-ZA/all';
// Angola
import '@progress/kendo-angular-intl/locales/pt-AO/all';
// Argentina
import '@progress/kendo-angular-intl/locales/es-AR/all';
// Canadá
import '@progress/kendo-angular-intl/locales/en-CA/all';
import '@progress/kendo-angular-intl/locales/fr-CA/all';
// Catalunha
import '@progress/kendo-angular-intl/locales/ca/all';
// Chile
import '@progress/kendo-angular-intl/locales/es-CL/all';
// Colômbia
import '@progress/kendo-angular-intl/locales/es-CO/all';
// Costa Rica
import '@progress/kendo-angular-intl/locales/es-CR/all';
// Equador
import '@progress/kendo-angular-intl/locales/es-EC/all';
// Guatemala
import '@progress/kendo-angular-intl/locales/es-GT/all';
// Inglaterra
import '@progress/kendo-angular-intl/locales/en-GB/all';
// Itália
import '@progress/kendo-angular-intl/locales/it/all';
// México
import '@progress/kendo-angular-intl/locales/es-MX/all';
// Nicarágua
import '@progress/kendo-angular-intl/locales/es-NI/all';
// Peru
import '@progress/kendo-angular-intl/locales/es-PE/all';
// Portugal
import '@progress/kendo-angular-intl/locales/pt-PT/all';
// República Dominicana
import '@progress/kendo-angular-intl/locales/es-DO/all';
/* Reports Dependencies */
import 'jquery';
import '@progress/kendo-ui/js/kendo.panelbar';
import '@progress/kendo-ui/js/kendo.menu';
import '@progress/kendo-ui/js/kendo.splitter';
import '@progress/kendo-ui/js/kendo.treeview';
import '@progress/kendo-ui/js/kendo.tooltip';
import '@ndk/ng-reports/kendo/viewer/js/telerikReportViewer-14.1.20.618';

/* Angular */
import { registerLocaleData } from '@angular/common';
import angularCa from '@angular/common/locales/ca';
import angularDe from '@angular/common/locales/de';
import angularEs from '@angular/common/locales/es';
import angularIt from '@angular/common/locales/It';
import angularPt from '@angular/common/locales/pt';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
/* TimeAgo */
import TimeAgo from 'javascript-time-ago';
import * as timeAgoCa from 'javascript-time-ago/locale/ca';
import * as timeAgoEn from 'javascript-time-ago/locale/en';
import * as timeAgoEs from 'javascript-time-ago/locale/es';
import * as timeAgoIt from 'javascript-time-ago/locale/it';
import * as timeAgoPt from 'javascript-time-ago/locale/pt';

import { AppModule } from './app/app.module';

((): void => {
    if (ENV === 'production') {
        enableProdMode();
    }

    TimeAgo.addLocale(timeAgoPt);
    TimeAgo.addLocale(timeAgoEn);
    TimeAgo.addLocale(timeAgoEs);
    TimeAgo.addLocale(timeAgoCa);
    TimeAgo.addLocale(timeAgoIt);

    registerLocaleData(angularCa);
    registerLocaleData(angularPt);
    registerLocaleData(angularEs);
    registerLocaleData(angularDe);
    registerLocaleData(angularIt);

    platformBrowserDynamic().bootstrapModule(AppModule);
})();
